import api from './api';

const base = '/api/payments/email-infra';

export async function fetchEmailInfraBillingAssets() {
  const { data } = await api.get(`${base}/assets`);
  return data;
}

export async function cancelMailbox(mailboxId) {
  const { data } = await api.post(`${base}/mailboxes/cancel`, { mailbox_id: mailboxId });
  return data;
}

export async function revertMailboxCancel(mailboxId) {
  const { data } = await api.post(`${base}/mailboxes/cancel/revert`, {
    mailbox_id: mailboxId,
  });
  return data;
}

export async function cancelDomain(domainId) {
  const { data } = await api.post(`${base}/domains/cancel`, { domain_id: domainId });
  return data;
}

export async function revertDomainCancel(domainId) {
  const { data } = await api.post(`${base}/domains/cancel/revert`, { domain_id: domainId });
  return data;
}
